import { render, staticRenderFns } from "./PencarianPasien.vue?vue&type=template&id=d6fd5058"
import script from "./PencarianPasien.vue?vue&type=script&lang=js"
export * from "./PencarianPasien.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6fd5058')) {
      api.createRecord('d6fd5058', component.options)
    } else {
      api.reload('d6fd5058', component.options)
    }
    module.hot.accept("./PencarianPasien.vue?vue&type=template&id=d6fd5058", function () {
      api.rerender('d6fd5058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/PencarianPasien.vue"
export default component.exports